import { useInfiniteQuery } from '@tanstack/react-query';

// React Query cache configuration
const STALE_TIME = 6 * 60 * 60 * 1000; // 6 hours
const CACHE_TIME = 6 * 60 * 60 * 1000; // 6 hours

import { fetchGNewsCategory } from '../services/newsApi';

const MAX_PAGES = 3; // 3 pages × 10 articles = 30 max

export const useNewsByCategory = (
  category: 'general' | 'world' | 'technology'
) => {
  return useInfiniteQuery({
    queryKey: ['gnews', category],
    queryFn: ({ pageParam }) => fetchGNewsCategory(category, pageParam as number),
    initialPageParam: 1,
    getNextPageParam: (_lastPage, allPages) => {
      const next = allPages.length + 1;
      return next <= MAX_PAGES ? next : undefined;
    },
    staleTime: STALE_TIME,
    gcTime: CACHE_TIME,
    retry: 2,
    retryDelay: 1000,
  });
};
